import { CalendarRangeIcon, MapPinIcon, StoreIcon } from 'lucide-react';
import { Link } from 'react-router';

import type { BillDTO } from '@invenco/common-interface/accounts';

import { Button } from '@/components/core/button';
import { DetailList } from '@/components/detail-list';

export function DetailsSection({ bill, isLoading }: { bill?: BillDTO; isLoading: boolean }) {
  return (
    <DetailList
      title="Details"
      isLoading={isLoading}
      items={[
        {
          icon: StoreIcon,
          label: 'Account',
          value: bill ? (
            <Button variant="link" size="inline" asChild>
              <Link to={`/accounts/${bill.accountId}`}>{bill.accountName}</Link>
            </Button>
          ) : undefined,
        },
        {
          icon: MapPinIcon,
          label: 'Location',
          value: bill ? (
            <Button variant="link" size="inline" asChild>
              <Link to={`/locations/${bill.locationId}`}>{bill.locationName}</Link>
            </Button>
          ) : undefined,
        },
        { icon: CalendarRangeIcon, label: 'From', value: bill?.periodStart },
        { icon: CalendarRangeIcon, label: 'To', value: bill?.periodEnd },
      ]}
    />
  );
}
